import React from "react";

const Footer = () => {
    return <h4>Made with React</h4>;
};

export default Footer;
